var _defs, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQuestionsIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "questions-icon",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".questions-icon .a{fill:#fff;stroke:#707070;opacity:0;}.questions-icon .b{fill:#acb5c0;}.questions-icon .c{stroke:none;}.questions-icon .d{fill:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 28,
    height: 28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    x: 0.5,
    y: 0.5,
    width: 27,
    height: 27
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.75 2.75)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M236.243,363.455a.787.787,0,1,1-.787-.787A.787.787,0,0,1,236.243,363.455Zm0,0",
    transform: "translate(-223.645 -345.632)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M11.81,23.621a11.81,11.81,0,1,1,11.81-11.81A11.824,11.824,0,0,1,11.81,23.621Zm0-22.145A10.334,10.334,0,1,0,22.145,11.81,10.346,10.346,0,0,0,11.81,1.476Zm0,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M168.678,93.8a.591.591,0,0,1-.591-.591v-.8a1.775,1.775,0,0,1,1.183-1.671,2.443,2.443,0,0,0,1.573-2.061,2.165,2.165,0,0,0-4.331,0,.591.591,0,1,1-1.181,0,3.346,3.346,0,1,1,6.693,0,3.623,3.623,0,0,1-2.361,3.176.591.591,0,0,0-.394.557v.795A.591.591,0,0,1,168.678,93.8Zm0,0",
    transform: "translate(-156.868 -80.756)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionsIcon);
export default __webpack_public_path__ + "static/media/questions-icon.e0f6ab2b509aa62d6c606f2203069331.svg";
export { ForwardRef as ReactComponent };